import React, { createContext } from 'react';

export const IncidentContext = createContext({});
